module.exports = __webpack_public_path__ + "img/schalke.f0ae01ce.png";